export function formatDate(value) {
  if (!value) {
    return "-";
  }

  const [year, month, day] = String(value).split("-");

  if (!year || !month || !day) {
    return value;
  }

  return `${day}.${month}.${year}`;
}

export function formatDateRange(startsOn, endsOn) {
  if (!startsOn && !endsOn) {
    return "-";
  }

  return `${startsOn ? formatDate(startsOn) : "-"} - ${
    endsOn ? formatDate(endsOn) : "Açık uçlu"
  }`;
}

export function getInvoiceSummaryLabel(summary) {
  if (!summary || !summary.has_invoice_items) {
    return "Faturalı dönem yok";
  }

  return `${formatDateRange(
    summary.first_billed_period_start,
    summary.latest_billed_period_end
  )} · ${summary.invoice_count || 0} fatura · ${
    summary.invoice_item_count || 0
  } satır`;
}
